// @flow
import React from 'react'
import classnames from 'classnames'

type PropsT = {
  path?: string,
  customId?: string,
  className?: string,
  stroke?: string,
  strokeWidth?: string,
  fill?: string,
  title?: string,
  viewBox?: string,
  renderPath?: Function,
}

const Icon = ({ path, customId='ic', className='', stroke='none', strokeWidth='1', fill='none', title='', viewBox='0 0 32 32', renderPath, }: PropsT) => (
  <svg className={classnames('Icon', className)} viewBox={viewBox} xmlns='http://www.w3.org/2000/svg'>
    <title>{title}</title>
    {renderPath
      ? renderPath()
      : (<g id={customId} fillRule="evenodd" stroke={stroke} fill={fill} strokeWidth={strokeWidth}>
        <path d={path} id="path-1"></path>
      </g>)
    }
  </svg>
)

export default Icon
